export const LOCATION_SEARCH_FILTER_BAR_ID = 'location-search-filter-bar';
export const LOCATION_SEARCH_RESULTS_LIST_ID = 'location-search-filter-bar';
export const LOCATION_SEARCH_HERO_COMMUNITY_PILLS_ID = 'hero-community-pills';

const SCROLL_BUFFER_PX = 2;

function getFixedHeaderOffset(): number {
  const layoutHeader = document.querySelector('.header');
  if (layoutHeader) {
    return layoutHeader.getBoundingClientRect().height;
  }

  const visibleHeader = ['desktop-header', 'mobile-header']
    .map((id) => document.getElementById(id))
    .find((element) => element && window.getComputedStyle(element).display !== 'none');

  return visibleHeader?.getBoundingClientRect().height ?? 0;
}

function scrollElementBelowHeader(elementId: string): void {
  const element = document.getElementById(elementId);
  if (!element) {
    return;
  }

  const headerOffset = getFixedHeaderOffset();
  const scrollMarginTop = parseFloat(window.getComputedStyle(element).scrollMarginTop) || 0;
  const offset = Math.max(headerOffset, scrollMarginTop) + SCROLL_BUFFER_PX;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  });
}

export function scrollToSection(isDesktopLayout: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  const targetId = isDesktopLayout
    ? LOCATION_SEARCH_FILTER_BAR_ID
    : LOCATION_SEARCH_RESULTS_LIST_ID;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollElementBelowHeader(targetId);
    });
  });
}

export function scrollToHeroCommunityPills(): void {
  if (typeof window === 'undefined') {
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollElementBelowHeader(LOCATION_SEARCH_HERO_COMMUNITY_PILLS_ID);
    });
  });
}
